module.exports = __webpack_public_path__ + "static/media/SourceSansPro-ExtraLight.f751a90a.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-ExtraLight.eot
// module id = 83
// module chunks = 3